export default __webpack_public_path__ + "static/media/StatusSuccessIcon.9fa06944.svg";